export default __webpack_public_path__ + "static/media/logo.26677fd4.png";